import * as basicConstants from './basic';

export const PAGE_LOGIN = '/login';
export const PAGE_MEDIA_MENU = '/media-menu';

export const PAGE_FB_SEND_LIST = '/fb-send-list';
export const PAGE_FB_CREATE_DATA = '/fb-create-data';
export const PAGE_FB_EDIT_DATA = '/fb-edit-data';

export const PAGE_GOOGLE_SEND_LIST = '/google-send-list';
export const PAGE_GOOGLE_CREATE_DATA = '/google-create-data';
export const PAGE_GOOGLE_EDIT_DATA = '/google-edit-data';

export const PAGE_LINE_SEND_LIST = '/line-send-list';
export const PAGE_LINE_CREATE_DATA = '/line-create-data';
export const PAGE_LINE_EDIT_DATA = '/line-edit-data';

export const PAGE_TABOOLA_SEND_LIST = '/taboola-send-list';
export const PAGE_TABOOLA_CREATE_DATA = '/taboola-create-data';
export const PAGE_TABOOLA_EDIT_DATA = '/taboola-edit-data';

//在報表編輯頁再次下載報表
export const PAGE_LINE_REDOWNLOAD = '/line-redownload';

export const PAGE_AD_ACCOUNTS = '/ad-accounts'
export const PAGE_AD_ACCOUNTS_CREATE = '/ad-accounts/create'

export const PAGE_USERS_TERMS = '/user-terms'
export const PAGE_PRIVACY = '/privacy'


export const PAGE_DATA = {
    login: {
        id: 'login',
        nav: false,
        path: '/login',
        title: '登入',
        allow: null,
        language: false,
    },
    mediaMenu: {
        id: 'media-menu',
        nav: false,
        path: '/media-menu',
        title: '媒體選單',
        allow: [
            basicConstants.AUTH_EDIT,
            basicConstants.AUTH_EDIT_REPORT,
            basicConstants.AUTH_BIND_AD_ACCOUNTS
        ],
        language: false,
    },
    facebookSendList: {
        id: 'facebook-send-list',
        nav: true,
        path: '/fb-send-list',
        title: 'Facebook報表寄送清單',
        allow: [basicConstants.AUTH_EDIT_REPORT],
        language: true,
    },
    facebookCreateData: {
        id: 'facebook-create-data',
        nav: true,
        path: '/fb-create-data',
        title: '建立Facebook報表資料',
        allow: [basicConstants.AUTH_EDIT_REPORT],
        language: true,
    },
    googleSendList: {
        id: 'google-send-list',
        nav: true,
        path: '/google-send-list',
        title: 'Google報表寄送清單',
        allow: [basicConstants.AUTH_EDIT_REPORT],
        language: true,
    },
    googleCreateData: {
        id: 'google-create-data',
        nav: true,
        path: '/google-create-data',
        title: '建立Google報表資料',
        allow: [basicConstants.AUTH_EDIT_REPORT],
        language: true,
    },
    lineSendList: {
        id: 'line-send-list',
        nav: true,
        path: '/line-send-list',
        title: 'LINE報表寄送清單',
        allow: [basicConstants.AUTH_EDIT_REPORT],
        language: false,
    },
    lineCreateData: {
        id: 'line-create-data',
        nav: true,
        path: '/line-create-data',
        title: '建立LINE報表資料',
        allow: [basicConstants.AUTH_EDIT_REPORT],
        language: false,
    },
    taboolaSendList: {
        id: 'taboola-send-list',
        nav: true,
        path: '/taboola-send-list',
        title: 'Taboola報表寄送清單',
        allow: [basicConstants.AUTH_EDIT_REPORT],
        language: false,
    },
    taboolaCreateData: {
        id: 'taboola-create-data',
        nav: true,
        path: '/taboola-create-data',
        title: '建立Taboola報表資料',
        allow: [basicConstants.AUTH_EDIT_REPORT],
        language: false,
    },
    adAccounts: {
        id: 'ad-accounts',
        nav: true,
        path: '/ad-accounts',
        title: '廣告帳號清單',
        allow: [basicConstants.AUTH_BIND_AD_ACCOUNTS],
        language: true,
    },
    adAccountsCreate: {
        id: 'ad-accounts-create',
        nav: true,
        path: '/ad-accounts/create',
        title: '新增廣告帳號',
        allow: [basicConstants.AUTH_BIND_AD_ACCOUNTS],
        language: true,
    },
    pravacy: {
        id: 'pravacy',
        nav: true,
        path: '/privacy',
        title: '隱私權政策',
        allow: null,
        language: false,
    },
    userTerms: {
        id: 'user-terms',
        nav: true,
        path: '/user-terms',
        title: '服務條款',
        allow: null,
        language: false,
    }
}